/* eslint-disable no-dupe-keys */
import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useQuery, { _get, _post } from "../../Utils/Helper";
import { Button, Dropdown, Menu } from "antd";
import FeesSetupModal from "./FeesSetupModal";
import { toast } from "react-toastify";
import {
  acadamicTerms,
  academicYear,
  school,
} from "../../../core/common/selectoption/selectoption";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";

const FeesSetup = () => {
  const navigate = useNavigate();
  const application_no = useQuery().get("application_no");

  interface Payment {
    id: string;
    code: string;
    status: string;
    description: string;
    section: string;
    student_type: string;
    amount: string;
    term: string;
    revenue_type: string;
    class_name: string;
    is_optional:string;
    school_id: number;
  }



 

  const [payments, setPayments] = useState<Payment[]>([]);
  const { academic_calendar } = useSelector((state: any) => state.auth);

  const [form, setForm] = useState({
    year: academic_calendar[0]?.academic_year,
    term: academic_calendar[0]?.term,
  });
  const _edit = {
    status: "Active",
    term: form.term,
    id:"",
    code:"",
    description:"",
    section:"",
    student_type:"",
    amount:"",
    revenue_type:"",
    class_name:"",
    is_optional:"",
    school_id:0
  }

  const getRevenueHeades = useCallback(()=>{
    _get(
      `school/revenues?query_type=select-all&academic_year=${form.year}&term=${form.term}&branch_id=${selected_branch?.branch_id}`,
      (resp) => {
        setPayments(resp.data);
      },
      (err) => {
        console.error(err);
      }
    );
  }, [form.year, form.term]);
  useEffect(() => {
    getRevenueHeades();
  }, [getRevenueHeades]);

  const [modalVisible, setModalVisible] = useState(false);
  const [editData, setEditData] = useState<Payment>(_edit);
  const { user, selected_branch } = useSelector((state: RootState) => state.auth);

  const handleModalSubmit = (formData: any) => {
   

    if (editData) {
      _post(
        `school/revenues`,
        {
          query_type: editData.id ? "update" : "create",
          id: editData.id,
          status: editData.status,
          ...formData,
          school_id: user.school_id,
          branch_id: selected_branch?.branch_id,
          account_type:"Revenue",
          academic_year: academic_calendar[0].academic_year
        },
        (resp) => {
          if (resp.success) {
            getRevenueHeades();
            toast.success("Updated successfully");
            setModalVisible(false);
            setEditData(_edit);
            setPayments((prev) =>
              prev?.map((item) =>
                item.code === editData.id ? { ...item, ...formData } : item
              )
            );
          }
        },
        (err) => {
          console.error(err);
          toast.error("Failed to update");
        }
      );
    }
  };

  const handleEdit = (payment: any) => {
    setEditData(payment);
    setModalVisible(true);
  };

  const handleDelete = (id: string) => {
    _get(
      `school/revenues?query_type=delete&id=${id}`,
      (resp) => {
        if (resp.success) {
          getRevenueHeades();
          toast.success("Deleted successfully");
          setPayments((prev) => prev.filter((item) => item.id !== id));
        }
      },
      (err) => {
        console.error(err);
        toast.error("Failed to delete");
      }
    );
  };

  const menu = (payment: any) => (
    <Menu>
      <Menu.Item key="edit" onClick={() => handleEdit(payment)}>
        Edit
      </Menu.Item>
      <Menu.Item key="delete" onClick={() => handleDelete(payment.id)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-xxl-12 col-xl-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                      <h4 className="mb-3">Fees</h4>
                      <div className="d-flex align-items-center flex-wrap">
                        <div className="dropdown mb-3 me-2">
                          <Link
                            to=""
                            className="btn btn-outline-light bg-white dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-calendar-due me-2" /> Year :{" "}
                            {form.year}
                          </Link>
                          <ul className="dropdown-menu p-0">
                            <li><Link
                              className="dropdown-item rounded-1"
                              to=""
                              onClick={() => {
                                setForm((p: any) => ({ ...p, year: '' }));
                              }}
                            >
                              <i className="ti ti-calendar-due me-2" />
                              General
                            </Link></li>
                            {academicYear?.map(year => (
                              <li key={year.value}>
                                <Link
                                  className="dropdown-item rounded-1"
                                  to=""
                                  onClick={() => {
                                    setForm((p: any) => ({
                                      ...p,
                                      year: year.value,
                                    }));
                                  }}
                                >
                                  <i className="ti ti-calendar-due me-2" />
                                  Year : {year.value}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>

                        <div className="dropdown mb-3 me-2">
                          <Link
                            to=""
                            className="btn btn-outline-light bg-white dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-filter me-2" />{" "}
                            {form.term || "General"}
                          </Link>
                          <ul className="dropdown-menu p-0">
                            {/* <li><Link
                              className="dropdown-item rounded-1"
                              to=""
                              onClick={() => {
                                setForm((p: any) => ({ ...p, term: '' }));
                              }}
                            >
                              <i className="ti ti-filter me-2" />
                              General
                            </Link>
                            </li> */}
                            {/* <li><Link
                              className="dropdown-item rounded-1"
                              to=""
                              onClick={() => {
                                setForm((p: any) => ({ ...p, term: 'Per Annum' }));
                              }}
                            >
                              <i className="ti ti-filter me-2" />
                              Per Annum
                            </Link></li> */}
                            {acadamicTerms?.map(term => (
                              <li key={term.value}>
                                <Link
                                  className="dropdown-item rounded-1"
                                  to=""
                                  onClick={() => {
                                    setForm((p: any) => ({
                                      ...p,
                                      term: term.value,
                                    }));
                                  }}
                                >
                                  <i className="ti ti-filter me-2" />
                                  {term.label}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="dropdown mb-3 me-2">
                          <Button
                            onClick={() => setModalVisible(true)}
                            className="btn btn-primary"
                            color="primary"
                          >
                            + Add new Fee
                          </Button>
                        </div>
                      </div>
                    </div>
                    <div className="card-body p-0 py-3">
                      {/* Fees List */}
                      <div className="custom-datatable-filter table-responsive">
                        <table className="table datatable">
                          <thead className="thead-light">
                            <tr>
                              <th>#</th>
                              <th>Description</th>
                              <th>Class</th>
                              <th>Amount (NGN)</th>
                              <th>Rev. type</th>
                              <th>Term</th>
                              <th>Is Optional</th>
                              <th>Status</th>
                              {/* <th>Due Date</th> */}
                              <th>Actions</th>
                            </tr>
                          </thead>
                          {/* {JSON.stringify([form.year, form.term])} */}
                          <tbody>
                            {payments?.map((payment: any, index: number) => (
                              <tr key={index}>
                                <td>{index+1}</td>
                                <td>
                                  <p className="text-primary fees-group">
                                    <span className="d-block">
                                      {payment?.description}
                                    </span>
                                  </p>
                                </td>

                                <td>{payment?.class_name}</td>
                                <td>{payment?.amount}</td>
                                <td>{payment?.revenue_type}</td>
                                <td>{payment?.term}</td>
                                <td>{payment?.is_optional}</td>
                                <td>
                                  <span className="badge badge-soft-success d-inline-flex align-items-center">
                                    <i className="ti ti-circle-filled fs-5 me-1" />
                                    {payment?.status}
                                  </span>
                                </td>
                                {/* <td>{payment?.}</td> */}
                                <td>
                                  <Dropdown
                                    overlay={menu(payment)}
                                    trigger={["click"]}
                                  >
                                    <Button className="btn btn-light">
                                      Actions
                                    </Button>
                                  </Dropdown>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <FeesSetupModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        onSubmit={handleModalSubmit}
        handleEdit={handleEdit}
        initialValues={editData}
      />
    </>
  );
};
export default FeesSetup;
